import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import type { EnrichedPendingKudoz } from '@shared/schema';

export function useKudozPending() {
  const { isAuthenticated } = useAuth();

  const { data = [], isLoading } = useQuery<EnrichedPendingKudoz[]>({
    queryKey: ['/api/kudoz/pending'],
    enabled: isAuthenticated,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });

  return {
    pendingKudoz: data,
    hasPending: data.length > 0,
    pendingCount: data.length,
    isLoading,
  };
}
